import React from "react";
import { Combo } from "../../common/components/comboBox";
import { BruciatoreDto } from "../../generated";
import { formGroup } from "../../common/components/formGroup";
import BruciatoriStore from "../bruciatoriStore";

const Combobox = Combo<BruciatoreDto>();
interface Props {
    marca: string;
    value: number | null,
    onChange: (bruciatore: BruciatoreDto) => void
    error?: string;
    label?: string;
    onBlur?: React.FocusEventHandler;
    onFocus?: React.FocusEventHandler;
}
const __BruciatoreSelector = ({ onChange, value, error, label, onBlur, onFocus, marca }: Props) => {
    const data = BruciatoriStore.useAll();
    if (!data)
        return null;
    return <Combobox
        label={label ?? "Caldaia"}
        allowNull
        data={data.filter(bruciatore => bruciatore.marcaBruciatore == marca)}
        textField={x => x.modelloBruciatore ?? ""}
        onSelect={onChange}
        value={data.find(caldaia => caldaia.idBruciatore == value) ?? null}
        error={error}
        onBlur={onBlur}
        onFocus={onFocus}
    />;
}
export const BruciatoreSelector = formGroup(__BruciatoreSelector)

